export default __webpack_public_path__ + "static/media/buy-technolology.1e8cebd6.png";